var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"20px","width":"20px"},domProps:{"innerHTML":_vm._s(_vm.avatars.create(_vm.seed))}})}
var staticRenderFns = []

export { render, staticRenderFns }